import React from 'react';


export default class IsolarMusculos extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Por que não isolar os músculos no treino?</strong><br /><br />
Quando elaboro um treino de “pernas”, seguimos a ciência do treinamento, e faço de 5 a 8 exercícios que englobem o máximo de fibras musculares por grupamento e não por músculo isolado. <br /><br />
Priorizamos os multiarticulares, pois além de potencializar a funcionalidade do corpo,são mais efetivos para todos os músculos envolvidos.<br /><br />
Os treinos de Dorsais sempre ativam os bíceps, e a ciência tem mostrado que cada série no treino de puxada e remada conta também como treino de bíceps, logo não faz sentido separar esses músculos e sim treina-los em conjunto. <br /><br />
O mesmo acontece com Peito, Ombros e tríceps: seja uma flexão no solo, ou supino, ativará igualmente as fibras dos peitorais, deltoides e tríceps. Então o mais razoável é treina-los juntos, e dar o descanso devido nos dias posteriores a todos eles.<br /><br />
Agachamento, hack machine e leg press – esses exercícios, em todas as suas variações, utilizam essencialmente os quadríceps (anterior de coxa), os bíceps femurais (posterior de coxa), os glúteos e os adutores (interno de coxas). Por isso, não faz sentido separar os treinos de pernas, a menos que você treine só cadeira extensora para quadríceps, só flexora para posterior e só abdutora e caneleiras para glúteo (se fizer isso seu resultado será um fiasco). O que fazem na maioria das academias é dizer que agachamento assim é para quadríceps e assado é para glúteo, mas isso não é verdade.<br /><br />
Exemplos:<br /><br />
Agachamento livre, com barra na frente ou nas costas: embora trabalhe todas as musculaturas citadas, parece ter um torque maior em quadríceps e glúteos. Terra/Meio<br /><br />
Terra/Stiff: igualmente trabalham todas as musculaturas, aumentando o torque nos glúteos e posteriores quando se deixa a perna mais estendida (stiff avançado).<br /><br />
Leg Press aberto/médio/alto/baixo: independente de qual seja a opção, todas as musculaturas (quadriceps, adutores, posterior e glúteos) são trabalhadas praticamente no mesmo torque, embora possamos usar as posições como efeito de variação.<br /><br />
Recuo – Avanço – Passada - Afundo: Esses formatos unilaterais de agachamento (agachar com uma perna) são particularmente interessantes e, embora trabalhem tão intensamente as musculaturas citadas, também geram um torque maior nos glúteos, adutores, abdutores e posterior, por causa da modificação do centro de massa (centralização do equilíbrio). Mas quando usamos esse exercício tão importante, estamos treinando fortemente o quadríceps (anterior de coxa).<br /><br />
Esqueçam os Mitos! A ciência é a coisa mais razoável a que se pode apoiar em se tratando de exercícios e seus resultados.


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/IsolarMusculos.js